function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7672_38699)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.4418 0H15.5582C6.96564 0 0 6.96564 0 15.5582V54.4418C0 63.0344 6.96564 70 15.5582 70H54.4418C63.0344 70 70 63.0344 70 54.4418V15.5582C70 6.96564 63.0344 0 54.4418 0Z",
  fill: "#434343"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.6523 30.1256H11.3477V22.7077C11.3477 18.6806 14.8197 15.2891 18.9427 15.2891H51.058C55.181 15.2891 58.653 18.6806 58.653 22.7077V30.1256H58.6523Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.6523 36.9713H11.3477V29.0872C11.3477 24.8074 14.8197 21.2031 18.9427 21.2031H51.058C55.181 21.2031 58.653 24.8074 58.653 29.0872V36.9713H58.6523Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.6523 43.5416H11.3477V35.6575C11.3477 31.3777 14.8197 27.7734 18.9427 27.7734H51.058C55.181 27.7734 58.653 31.3777 58.653 35.6575V43.5416H58.6523Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3477 32.0297L41.372 38.812C44.8279 39.6597 48.7164 38.812 51.5241 36.6924L58.6522 31.6055V47.5018C58.6522 51.5289 55.1963 54.7083 51.0922 54.7083H18.9077C14.8036 54.7083 11.3477 51.5289 11.3477 47.5018V32.029V32.0297Z",
  fill: "url(#paint0_linear_7672_38699)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7672_38699",
  x1: 32.788,
  y1: 43.6343,
  x2: 8.47624,
  y2: 72.1201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4285F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B74E8"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7672_38699"
}, /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 70,
  fill: "white"
})));

var SvgGoogleWallet = function SvgGoogleWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_wallet.4b784c9c.svg";
export { ForwardRef as ReactComponent };